import { render, staticRenderFns } from "./TournamentRankings.vue?vue&type=template&id=4e13f2fa&scoped=true&"
import script from "./TournamentRankings.vue?vue&type=script&lang=js&"
export * from "./TournamentRankings.vue?vue&type=script&lang=js&"
import style0 from "./TournamentRankings.vue?vue&type=style&index=0&id=4e13f2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13f2fa",
  null
  
)

component.options.__file = "TournamentRankings.vue"
export default component.exports